import React, { createContext, useState } from 'react'

export const ThemeContext = createContext()

const blueThemeLight = {
    type: 'light',
    primary: '#60a5fa',
    secondary: '#f6f8fb',
    tertiary: '#0f172a',
}

const blueThemeDark = {
    type: 'dark',
    primary: '#60a5fa',
    secondary: '#070a10',
    tertiary: '#eef4ff',
}

function ThemeContextProvider(props) {
    const [isDark, setIsDark] = useState(true)
    const theme = isDark ? blueThemeDark : blueThemeLight
    const [drawerOpen, setDrawerOpen] = useState(false)

    const setHandleDrawer = () => {
        setDrawerOpen(!drawerOpen)
    }

    const toggleTheme = () => setIsDark(prev => !prev)

    const value = { theme, isDark, toggleTheme, drawerOpen, setHandleDrawer }
    return (
        <ThemeContext.Provider value={value}>
            {props.children}
        </ThemeContext.Provider>
    )
}


export default ThemeContextProvider
